<template>
  <!-- <svg fill="#b0b0b0" fill-opacity="0.24" height="18" viewBox="0 0 24 24" width="18" xmlns="http://www.w3.org/2000/svg" @click="$emit('doToggleHighlight')">
    <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
    <path d="M0 0h24v24H0z" fill="none"/>
  </svg> -->
  <svg @click="$emit('doToggleHighlight')" fill="#000000" fill-opacity="0.24" version="1.1" id="highlight-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 344.406 344.406" style="enable-background:new 0 0 344.406 344.406;" xml:space="preserve">
  <g>
    <g>
      <path d="M243.243,0h-142.08c-13.767,0.044-24.916,11.193-24.96,24.96v298.8c0,21,21.04,31.2,37.48,5l58.52-93.28l58.52,93.28
        c16.44,26.2,37.48,15.96,37.48-5V24.96C268.159,11.193,257.01,0.044,243.243,0z"/>
    </g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  <g>
  </g>
  </svg>
</template>

<script>
export default {
  name: 'Highlighter'
}
</script>

<style scoped lang="scss">
  #highlight-icon {
    width: 18px;
    height: 18px;
  }
</style>


// WEBPACK FOOTER //
// src/components/assets/Highlighter.vue